module.exports = __webpack_public_path__ + "media/images/ui__arrowRight--dark-b3eb9af040400b0032059a292fc2194f.png";